import axios from "axios"

export const getConsultants = () => {
    return axios.get(`${process.env.REACT_APP_IDP_Api}user/consultants`);
}

export const getConsultant = (id) => {
    return axios.get(`${process.env.REACT_APP_IDP_Api}user/consultant/${id}`);
}